// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3XRm-","subheader":"ReorderModal_subheader__3LBNS","listWrap":"ReorderModal_listWrap__WymNr"};